import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import css from './Message.css';
import { useMessageContext } from './useMessageContext';

const FileMessage = ({ imageClassName }) => {
    const { fileIsImage, fileIsDoc, message } = useMessageContext();

    const { attributes } = message || {};
    const { file } = attributes || {};

    if (fileIsImage) {
        return <img alt="Nachricht aus dem Chat" className={imageClassName} src={file.url} />;
    }

    if (fileIsDoc) {
        return (
            <>
                <FormattedMessage id="ActivityFeed.downloadTheFile" />
                <br />
                <a href={file.url} target="_blank" className={css.s3Doc}>
                    {file.fileName}
                </a>
            </>
        );
    }

    return null;
};

export default FileMessage;
